export default {
    orchestrator:{
        createStack: "/orchestrator/create"
    },
    fakeDemo: "/fake",
    //Explicitly denied
    iacAggregationDisabled: "iacAggregationDisabled",
    dynamicHclDisabled: 'oldReverseLearning'
};